
import Navbar from '../visa-travel-tips/components/Navbar';
import Footer from '../visa-travel-tips/components/Footer';

export default function TravelBudget() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Chi phí dự trù khi du lịch Mỹ
            </h1>
            <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Hướng dẫn chi tiết về ngân sách và lập kế hoạch tài chính cho chuyến đi
            </p>
          </div>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <a href="/" className="hover:text-teal-600 transition-colors">Trang chủ</a>
            <span>/</span>
            <a href="/visa-travel-tips" className="hover:text-teal-600 transition-colors">Kinh nghiệm du lịch</a>
            <span>/</span>
            <span className="text-gray-900 font-medium">Chi phí dự trù</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Tổng quan ngân sách */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-money-dollar-circle-line text-blue-600"></i>
                Tổng quan ngân sách du lịch Mỹ
              </h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <div className="text-3xl mb-3">💰</div>
                  <h3 className="font-bold text-green-600 text-2xl mb-2">$2,000 - $3,500</h3>
                  <p className="text-sm text-gray-600">Budget trip 7-10 ngày</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <div className="text-3xl mb-3">✈️</div>
                  <h3 className="font-bold text-blue-600 text-2xl mb-2">$3,500 - $6,000</h3>
                  <p className="text-sm text-gray-600">Mid-range 7-10 ngày</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <div className="text-3xl mb-3">🌟</div>
                  <h3 className="font-bold text-purple-600 text-2xl mb-2">$6,000+</h3>
                  <p className="text-sm text-gray-600">Luxury 7-10 ngày</p>
                </div>
              </div>
            </div>
          </section>

          {/* Vé máy bay */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-plane-line text-blue-600"></i>
              Vé máy bay (25-40% tổng chi phí)
            </h2>

            <div className="bg-white border border-gray-200 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6">💺 Bảng giá vé máy bay từ Việt Nam</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-gray-50 border-b">
                      <th className="text-left p-4 font-medium">Hạng vé</th>
                      <th className="text-left p-4 font-medium">Mùa thấp điểm</th>
                      <th className="text-left p-4 font-medium">Mùa cao điểm</th>
                      <th className="text-left p-4 font-medium">Lưu ý</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b">
                      <td className="p-4 font-medium">Economy</td>
                      <td className="p-4 text-green-600">$800 - $1,200</td>
                      <td className="p-4 text-red-600">$1,500 - $2,500</td>
                      <td className="p-4">Đặt trước 2-3 tháng</td>
                    </tr>
                    <tr className="border-b">
                      <td className="p-4 font-medium">Premium Economy</td>
                      <td className="p-4 text-green-600">$1,800 - $2,500</td>
                      <td className="p-4 text-red-600">$3,000 - $4,000</td>
                      <td className="p-4">Ghế rộng hơn, ăn tốt hơn</td>
                    </tr>
                    <tr>
                      <td className="p-4 font-medium">Business</td>
                      <td className="p-4 text-green-600">$4,000 - $6,000</td>
                      <td className="p-4 text-red-600">$8,000 - $12,000</td>
                      <td className="p-4">Ghế nằm, lounge</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">💡 Mẹo tiết kiệm vé máy bay</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Tránh mùa cao điểm (6-8, 11-1)</li>
                  <li>• Bay giữa tuần (T3, T4, T5)</li>
                  <li>• Theo dõi giá 4-6 tuần</li>
                  <li>• Xem xét bay quá cảnh</li>
                  <li>• Sử dụng dặm tích lũy</li>
                </ul>
              </div>
              
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4">📋 Chi phí phụ trội</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Hành lý ký gửi: $25-50/chiếc</li>
                  <li>• Chọn chỗ ngồi: $10-100</li>
                  <li>• Suất ăn đặc biệt: $15-30</li>
                  <li>• Bảo hiểm hủy chuyến: $50-200</li>
                  <li>• Phí đổi vé: $200-500</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Lưu trú */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-hotel-line text-blue-600"></i>
              Lưu trú (20-35% tổng chi phí)
            </h2>

            <div className="bg-purple-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-purple-900">🏨 Chi phí lưu trú theo thành phố</h3>
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-bold text-purple-800 mb-2">New York</h4>
                  <div className="space-y-1 text-sm">
                    <div>Budget: $50-100</div>
                    <div>Mid: $150-300</div>
                    <div>Luxury: $400+</div>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-bold text-purple-800 mb-2">San Francisco</h4>
                  <div className="space-y-1 text-sm">
                    <div>Budget: $40-80</div>
                    <div>Mid: $120-250</div>
                    <div>Luxury: $350+</div>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-bold text-purple-800 mb-2">Los Angeles</h4>
                  <div className="space-y-1 text-sm">
                    <div>Budget: $35-70</div>
                    <div>Mid: $100-200</div>
                    <div>Luxury: $300+</div>
                  </div>
                </div>
                <div className="bg-white rounded-lg p-4">
                  <h4 className="font-bold text-purple-800 mb-2">Las Vegas</h4>
                  <div className="space-y-1 text-sm">
                    <div>Budget: $25-60</div>
                    <div>Mid: $80-180</div>
                    <div>Luxury: $250+</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-3">🏠 Airbnb/Vacation Rental</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Tiết kiệm 20-40% vs khách sạn</li>
                  <li>• Có bếp để nấu ăn</li>
                  <li>• Phù hợp nhóm đông người</li>
                  <li>• Phí dọn dẹp: $50-150</li>
                </ul>
              </div>
              
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-3">🏨 Khách sạn</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Dịch vụ đầy đủ, ổn định</li>
                  <li>• Có chương trình loyalty</li>
                  <li>• Dọn phòng hàng ngày</li>
                  <li>• Resort fee: $15-45/đêm</li>
                </ul>
              </div>
              
              <div className="bg-yellow-50 rounded-lg p-6">
                <h4 className="font-semibold text-yellow-900 mb-3">🏕️ Hostel</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Rẻ nhất: $20-60/đêm</li>
                  <li>• Gặp gỡ du khách khác</li>
                  <li>• Bếp chung, giặt ủi</li>
                  <li>• Phòng riêng: +$20-50</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Ăn uống */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-restaurant-2-line text-blue-600"></i>
              Ăn uống (15-25% tổng chi phí)
            </h2>

            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-orange-900">🍽️ Chi phí ăn uống hàng ngày</h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-orange-800 mb-4 text-center">Budget</h4>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                      <span>Sáng:</span>
                      <span className="font-medium">$5-12</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Trưa:</span>
                      <span className="font-medium">$8-18</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Tối:</span>
                      <span className="font-medium">$15-30</span>
                    </div>
                    <div className="border-t pt-2 flex justify-between font-bold">
                      <span>Tổng/ngày:</span>
                      <span className="text-green-600">$30-60</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-orange-800 mb-4 text-center">Mid-range</h4>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                      <span>Sáng:</span>
                      <span className="font-medium">$12-25</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Trưa:</span>
                      <span className="font-medium">$20-40</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Tối:</span>
                      <span className="font-medium">$35-80</span>
                    </div>
                    <div className="border-t pt-2 flex justify-between font-bold">
                      <span>Tổng/ngày:</span>
                      <span className="text-blue-600">$70-150</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-orange-800 mb-4 text-center">Fine Dining</h4>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                      <span>Sáng:</span>
                      <span className="font-medium">$25-50</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Trưa:</span>
                      <span className="font-medium">$50-100</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Tối:</span>
                      <span className="font-medium">$100-300</span>
                    </div>
                    <div className="border-t pt-2 flex justify-between font-bold">
                      <span>Tổng/ngày:</span>
                      <span className="text-purple-600">$200-500</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">🥪 Lựa chọn budget-friendly</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Food truck: $5-15/món</li>
                  <li>• Fast casual: $8-20/món</li>
                  <li>• Grocery store: $30-50/ngày</li>
                  <li>• Happy hour: Giảm 30-50%</li>
                  <li>• Lunch specials: $10-25</li>
                </ul>
              </div>
              
              <div className="bg-red-50 rounded-lg p-6">
                <h4 className="font-semibold text-red-900 mb-4">💸 Chi phí bổ sung</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Tip: 18-25% hóa đơn</li>
                  <li>• Tax: 6-12% tùy bang</li>
                  <li>• Delivery fee: $2-8</li>
                  <li>• Đồ uống có cồn: +$8-20</li>
                  <li>• Nước uống: $2-5/chai</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Di chuyển */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-car-line text-blue-600"></i>
              Di chuyển (10-20% tổng chi phí)
            </h2>

            <div className="bg-blue-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-blue-900">🚗 So sánh chi phí di chuyển (per day)</h3>
              <div className="overflow-x-auto">
                <table className="w-full text-sm bg-white rounded-lg">
                  <thead>
                    <tr className="bg-gray-50 border-b">
                      <th className="text-left p-4 font-medium">Phương tiện</th>
                      <th className="text-left p-4 font-medium">Chi phí cơ bản</th>
                      <th className="text-left p-4 font-medium">Chi phí phụ</th>
                      <th className="text-left p-4 font-medium">Tổng/ngày</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b">
                      <td className="p-4 font-medium">Thuê xe</td>
                      <td className="p-4">$25-80</td>
                      <td className="p-4">Gas: $15-40, Parking: $10-50</td>
                      <td className="p-4 font-bold text-orange-600">$50-170</td>
                    </tr>
                    <tr className="border-b">
                      <td className="p-4 font-medium">Uber/Lyft</td>
                      <td className="p-4">$15-25/ride</td>
                      <td className="p-4">Tip: 15-20%, Surge: +50-200%</td>
                      <td className="p-4 font-bold text-blue-600">$60-150</td>
                    </tr>
                    <tr className="border-b">
                      <td className="p-4 font-medium">Taxi</td>
                      <td className="p-4">$3-5 base + $2-4/mile</td>
                      <td className="p-4">Tip: 15-20%</td>
                      <td className="p-4 font-bold text-yellow-600">$40-120</td>
                    </tr>
                    <tr>
                      <td className="p-4 font-medium">Public Transit</td>
                      <td className="p-4">$2-8/ride</td>
                      <td className="p-4">Day pass: $10-25</td>
                      <td className="p-4 font-bold text-green-600">$10-30</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-yellow-50 rounded-lg p-6">
                <h4 className="font-semibold text-yellow-900 mb-4">✈️ Domestic flights</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Coast to coast: $150-600</li>
                  <li>• Regional: $80-300</li>
                  <li>• Đặt trước 3-8 tuần</li>
                  <li>• Spirit, Frontier: Rẻ nhưng phí nhiều</li>
                  <li>• Carry-on fee: $35-65</li>
                </ul>
              </div>
              
              <div className="bg-purple-50 rounded-lg p-6">
                <h4 className="font-semibold text-purple-900 mb-4">🚌 Long-distance</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Greyhound: $50-200 cross-country</li>
                  <li>• Megabus: $20-100 (book early)</li>
                  <li>• Amtrak: $100-500 tùy tuyến</li>
                  <li>• Chậm nhưng ngắm cảnh đẹp</li>
                  <li>• Sleeper car: +$200-800</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Tham quan giải trí */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-camera-2-line text-blue-600"></i>
              Tham quan & Giải trí (10-25% tổng chi phí)
            </h2>

            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-xl p-8 mb-6">
              <h3 className="text-xl font-semibold mb-6 text-indigo-900">🎟️ Bảng giá tham quan phổ biến</h3>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-indigo-800 mb-4">New York City</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex justify-between">
                      <span>Empire State Building</span>
                      <span className="font-medium">$42</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Statue of Liberty</span>
                      <span className="font-medium">$24</span>
                    </li>
                    <li className="flex justify-between">
                      <span>9/11 Memorial</span>
                      <span className="font-medium">$29</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Broadway show</span>
                      <span className="font-medium">$80-350</span>
                    </li>
                    <li className="flex justify-between border-t pt-2">
                      <span>NYC CityPass</span>
                      <span className="font-medium text-green-600">$132</span>
                    </li>
                  </ul>
                </div>
                
                <div className="bg-white rounded-lg p-6">
                  <h4 className="font-bold text-indigo-800 mb-4">Los Angeles</h4>
                  <ul className="space-y-2 text-sm">
                    <li className="flex justify-between">
                      <span>Universal Studios</span>
                      <span className="font-medium">$109</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Disneyland</span>
                      <span className="font-medium">$104</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Getty Center</span>
                      <span className="font-medium text-green-600">Free</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Hollywood Walk</span>
                      <span className="font-medium text-green-600">Free</span>
                    </li>
                    <li className="flex justify-between border-t pt-2">
                      <span>Go Los Angeles</span>
                      <span className="font-medium text-green-600">$75/day</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="font-semibold text-green-900 mb-4">🆓 Miễn phí</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Smithsonian Museums (DC)</li>
                  <li>• Central Park (NYC)</li>
                  <li>• Golden Gate Park (SF)</li>
                  <li>• Venice Beach (LA)</li>
                  <li>• Walking tours (tips)</li>
                </ul>
              </div>
              
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="font-semibold text-blue-900 mb-4">🎫 City Pass</h4>
                <ul className="space-y-2 text-sm">
                  <li>• NYC: $132 (tiết kiệm 40%)</li>
                  <li>• SF: $76 (tiết kiệm 40%)</li>
                  <li>• Chicago: $109 (tiết kiệm 48%)</li>
                  <li>• Go City: $35-150/ngày</li>
                  <li>• Explorer Pass: $59-179</li>
                </ul>
              </div>
              
              <div className="bg-red-50 rounded-lg p-6">
                <h4 className="font-semibold text-red-900 mb-4">🎬 Entertainment</h4>
                <ul className="space-y-2 text-sm">
                  <li>• Movie ticket: $12-25</li>
                  <li>• Concert: $50-300+</li>
                  <li>• Sports game: $25-500+</li>
                  <li>• Comedy show: $20-80</li>
                  <li>• Nightclub: $20-100 cover</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Chi phí khác */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
              <i className="ri-shopping-cart-line text-blue-600"></i>
              Chi phí phụ khác (5-15% tổng chi phí)
            </h2>

            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-orange-50 rounded-lg p-6">
                <h4 className="font-semibold text-orange-900 mb-4">📱 Liên lạc & Internet</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between">
                    <span>SIM card tourist</span>
                    <span className="font-medium">$30-60</span>
                  </li>
                  <li className="flex justify-between">
                    <span>International roaming</span>
                    <span className="font-medium">$10-20/ngày</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Pocket WiFi</span>
                    <span className="font-medium">$8-15/ngày</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Free WiFi</span>
                    <span className="font-medium text-green-600">$0</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-purple-50 rounded-lg p-6">
                <h4 className="font-semibold text-purple-900 mb-4">🛍️ Mua sắm & Quà lưu niệm</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between">
                    <span>Quà lưu niệm</span>
                    <span className="font-medium">$50-200</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Quần áo</span>
                    <span className="font-medium">$100-1000+</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Điện tử</span>
                    <span className="font-medium">$200-2000+</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Tax (sales tax)</span>
                    <span className="font-medium">6-12%</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-yellow-50 rounded-lg p-6">
                <h4 className="font-semibold text-yellow-900 mb-4">💊 Y tế & Khẩn cấp</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between">
                    <span>Bảo hiểm du lịch</span>
                    <span className="font-medium">$30-150</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Thuốc OTC</span>
                    <span className="font-medium">$10-50</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Doctor visit</span>
                    <span className="font-medium">$200-500</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Emergency room</span>
                    <span className="font-medium">$1000-5000+</span>
                  </li>
                </ul>
              </div>
              
              <div className="bg-teal-50 rounded-lg p-6">
                <h4 className="font-semibold text-teal-900 mb-4">💳 Phí ngân hàng</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex justify-between">
                    <span>ATM fee</span>
                    <span className="font-medium">$3-8/lần</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Foreign transaction</span>
                    <span className="font-medium">2-3%</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Currency exchange</span>
                    <span className="font-medium">3-5%</span>
                  </li>
                  <li className="flex justify-between">
                    <span>Travel card (0% fee)</span>
                    <span className="font-medium text-green-600">Recommended</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Kế hoạch ngân sách mẫu */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">📊 Kế hoạch ngân sách mẫu 10 ngày</h2>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-gradient-to-b from-green-500 to-green-600 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-6 text-center">💰 BUDGET TRIP</h3>
                <div className="space-y-4">
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Vé máy bay:</span>
                    <span className="font-bold">$1,000</span>
                  </div>
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Lưu trú (10 đêm):</span>
                    <span className="font-bold">$400</span>
                  </div>
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Ăn uống:</span>
                    <span className="font-bold">$400</span>
                  </div>
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Di chuyển:</span>
                    <span className="font-bold">$200</span>
                  </div>
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Tham quan:</span>
                    <span className="font-bold">$300</span>
                  </div>
                  <div className="flex justify-between border-b border-green-300 pb-2">
                    <span>Chi phí khác:</span>
                    <span className="font-bold">$200</span>
                  </div>
                  <div className="flex justify-between text-xl font-bold border-t-2 border-green-300 pt-4">
                    <span>TỔNG CỘNG:</span>
                    <span>$2,500</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-to-b from-blue-500 to-blue-600 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-6 text-center">✈️ MID-RANGE</h3>
                <div className="space-y-4">
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Vé máy bay:</span>
                    <span className="font-bold">$1,200</span>
                  </div>
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Lưu trú (10 đêm):</span>
                    <span className="font-bold">$1,200</span>
                  </div>
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Ăn uống:</span>
                    <span className="font-bold">$1,000</span>
                  </div>
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Di chuyển:</span>
                    <span className="font-bold">$600</span>
                  </div>
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Tham quan:</span>
                    <span className="font-bold">$800</span>
                  </div>
                  <div className="flex justify-between border-b border-blue-300 pb-2">
                    <span>Chi phí khác:</span>
                    <span className="font-bold">$400</span>
                  </div>
                  <div className="flex justify-between text-xl font-bold border-t-2 border-blue-300 pt-4">
                    <span>TỔNG CỘNG:</span>
                    <span>$5,200</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-gradient-to-b from-purple-500 to-purple-600 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-6 text-center">🌟 LUXURY</h3>
                <div className="space-y-4">
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Vé máy bay:</span>
                    <span className="font-bold">$5,000</span>
                  </div>
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Lưu trú (10 đêm):</span>
                    <span className="font-bold">$4,000</span>
                  </div>
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Ăn uống:</span>
                    <span className="font-bold">$3,000</span>
                  </div>
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Di chuyển:</span>
                    <span className="font-bold">$1,500</span>
                  </div>
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Tham quan:</span>
                    <span className="font-bold">$2,000</span>
                  </div>
                  <div className="flex justify-between border-b border-purple-300 pb-2">
                    <span>Chi phí khác:</span>
                    <span className="font-bold">$1,500</span>
                  </div>
                  <div className="flex justify-between text-xl font-bold border-t-2 border-purple-300 pt-4">
                    <span>TỔNG CỘNG:</span>
                    <span>$17,000</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Lời khuyên */}
          <section className="mb-12">
            <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-6 text-center">💡 Lời khuyên lập ngân sách thông minh</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="font-semibold mb-4 text-orange-100">📝 Trước khi đi:</h3>
                  <ul className="space-y-2 text-sm text-orange-100">
                    <li>• Lập ngân sách chi tiết từng mục</li>
                    <li>• Để dành 20% cho phát sinh</li>
                    <li>• Mở thẻ tín dụng 0% foreign fee</li>
                    <li>• Tải app theo dõi chi tiêu</li>
                    <li>• Mua bảo hiểm du lịch</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-4 text-orange-100">💰 Trong chuyến đi:</h3>
                  <ul className="space-y-2 text-sm text-orange-100">
                    <li>• Ghi chép mọi khoản chi tiêu</li>
                    <li>• Sử dụng thẻ thay vì tiền mặt</li>
                    <li>• So sánh giá trước khi mua</li>
                    <li>• Tận dụng happy hour, deals</li>
                    <li>• Đặt límit hàng ngày</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-xl p-8 text-white text-center">
            <h3 className="text-2xl font-bold mb-4">Cần hỗ trợ lập kế hoạch ngân sách?</h3>
            <p className="mb-6 text-teal-100">
              Chúng tôi sẽ giúp bạn tính toán và lập kế hoạch chi tiết cho chuyến đi!
            </p>
            <div className="flex flex-col gap-3 max-w-md mx-auto">
              <button className="bg-white text-teal-600 px-8 py-3 rounded-lg text-lg font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
                Tư vấn ngân sách miễn phí
              </button>
              <button className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-3 rounded-lg text-lg font-semibold border-2 border-white transition-colors whitespace-nowrap cursor-pointer">
                Tải Excel tính ngân sách
              </button>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}
